import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

export function hasSubsidy(offer: MobilePlanOffer): boolean {
  return parseInt(offer.subsidy.amount, 10) > 0
}
